import React from "react";
import { DataGrid, GridCallbackDetails, GridCellModesModel, GridEventListener, GridColDef, GridEditMode, GridRowId, GridSelectionModel, GridRowModesModel } from "@mui/x-data-grid";
import CustomPagination from "../pagination/Pagination";
import "./Table.css";
import { observer } from 'mobx-react';
import { Checkbox } from "@mui/material";
import AddCircleIcon from "../icons/AddCircleIcon";
import RemoveCircleIcon from "../icons/RemoveCircleIcon";

type Props = {
  rows: any[];
  columns: GridColDef[];
  handleSortModelChange?: (field : string, sort : string) => void;
  isLoading?: boolean;
  withCheckbox?: boolean;
  withAllCheckbox?: boolean;
  selectedRowsData?: GridRowId[];
  pageSize?: number;
  setPageSize?: (value: number) => void;
  page?: number;
  setPage?: (value: number) => void;
  totalRecordsInDB?: number;
  totalFiltered?: number;

	onRowUnselected?: (id : GridRowId) => void;
	onRowSelected?: (id : GridRowId) => void;
};

const disableSelectAllCheckboxCSS = {
  "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
    display: "none"
  }
};

function DataTable(props: Props) {
  const { rows, columns, page, setPage, pageSize, setPageSize, totalRecordsInDB, totalFiltered, isLoading } = props;

  return (
    <div className="table-container">
      <DataGrid
        className="non-clickable-headers"
        sx={{ ...disableSelectAllCheckboxCSS }}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalRecordsInDB ?? rows.length}
        page={page ?? 0}
        pageSize={pageSize}
        loading={isLoading}
        {...({ disableSelectionOnClick: true } as any)}
        {...({ disableRowSelectionOnClick: true } as any)}
        components={{
          Pagination: () => (
            <CustomPagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalFiltered={totalFiltered}
            />
          ),
          NoRowsOverlay: () => <div />,
          BaseCheckbox: React.forwardRef((p: any, ref: any) => (
            <Checkbox icon={<AddCircleIcon />} checkedIcon={<RemoveCircleIcon />} {...p} ref={ref} />
          ))
        }}
      />
    </div>
  );
}

export default observer(DataTable);